<template>
  <div class="supplier-block">
    <div
      v-if="supplierLogo"
      class="supplier-block__brand"
    >
      <epi-picture
        :image="supplierLogo"
        :use-picture="false"
        :auto-aspect-ratio="true"
        :fit-dimensions="true"
        :sizes="logoDimensions"
      />
    </div>
    <epi-picture
      v-if="image"
      ref="heroImage"
      class="supplier-block__product"
      :image="image"
      :sizes="sizeSettings"
    />
    <div class="supplier-block__content">
      <h2 class="supplier-block__content__title">
        {{ title }}
      </h2>
      <wysiwyg
        v-if="content || isEditable"
        v-edit="'Content'"
        :content="content"
        class="supplier-block__content__text"
      />
      <a
        v-if="primaryButtonLabel"
        :href="primaryUrl"
        :target="isExternalUrl(primaryUrl)"
        class="button button--40 button--primary"
      >
        {{ primaryButtonLabel }}
      </a>
      <a
        v-if="secondaryButtonLabel"
        :href="secondaryUrl"
        :target="isExternalUrl(secondaryUrl)"
        class="button button--40 button--secondary"
      >
        {{ secondaryButtonLabel }}
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SupplierBlock",
    props: {
      title: {
        type: String,
        required: true
      },
      content: {
        type: Array,
        required: true
      },
      image: {
        type: Object,
        default: null
      },
      primaryButtonLabel: {
        type: String,
        default: ""
      },
      secondaryButtonLabel: {
        type: String,
        default: ""
      },
      primaryUrl: {
        type: String,
        default: ""
      },
      secondaryUrl: {
        type: String,
        default: ""
      },
      supplierLogo: {
        type: Object,
        default: null
      }
    },
    data () {
      return {
        imageDimensions: {
          small: {
            height: 232,
            width: 311
          },
          medium: {
            height: 152,
            width: 152
          },
          large: {
            height: 1232,
            width: 1232
          }
        },
        logoDimensions: {
          small: {
            height: 80,
            width: 80
          },
          medium: {
            height: 80,
            width: 80
          },
          large: {
            height: 176,
            width: 176
          }
        }
      }
    },
    computed: {
      sizeSettings () {
        const all = {
          ...this.imageDimensions,
          ...this.logoDimensions
        }
        return all
      }
    },
    methods: {
      isExternalUrl (url) {
        return !/^https?:\/\//i.test(url) ? "" : "_blank"
      },
    }
  }
</script>

<style lang="scss">
.supplier-block {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas: "brand" "product" "content";
  border-bottom: 1px solid #ededed;
  gap: 1rem;
  padding-bottom: 2rem;
  margin-top: 2rem;
  margin-bottom: 1rem;

  @include media-breakpoint-up(md) {
    grid-template-columns: 170px 1fr;
    grid-template-areas: "brand brand" "product content";
  }

  @include media-breakpoint-up(xl) {
    grid-template-columns: 192px 1fr;
  }

  &__brand {
    grid-area: brand;
    display: grid;
    grid-template-columns: 1fr 80px 1fr;
    align-items: center;
    justify-content: center;

    .epi-picture {
      width: 80px;
      height: 80px;

      .epi-background-container {
        background-size: contain;
      }
    }

    &::before,
    &::after {
      content: "";
      height: 1px;
      max-width: 100%;
      background-color: #ededed;
    }

    &::before {
      margin-right: 1rem;
    }

    &::after {
      margin-left: 1rem;
    }
  }

  &__product {
    grid-area: product;
    display: grid;
    align-content: center;
    justify-content: center;
    width: 100%;
  }

  &__content {
    grid-area: content;
    display: grid;
    justify-items: flex-start;
    align-self: flex-start;

    &__title {
      @include font(rubrik, 2, "bold");

      margin: 0 0 0.5rem 0;
    }

    &__text {
      @include font(text, 3, "light");

      margin: 0 0 0.5rem 0;
    }

    .button + .button {
      margin-top: 0.5rem;
    }
  }
}
</style>
